import React from 'react';
import { Button, message, Tooltip } from 'antd';
import { Copy } from 'lucide-react';
import { InvoiceV2 } from '@/store/invoice/useGetInvoicesV2';
import { isExpiredInvoice } from '../const';
import * as S from '../styled';

type Props = Pick<InvoiceV2, 'barcode' | 'status'>;

export function BarcodeCell({ barcode, status }: Props) {
    if (isExpiredInvoice({ status, barcode })) {
        return (
            <S.ExpiredBox>
                <strong>Boleto expirado</strong>
                <span>
                    Entre em contato com o suporte para solicitar um novo boleto
                </span>
            </S.ExpiredBox>
        );
    }

    if (!barcode) return <S.Muted>—</S.Muted>;

    const copy = async () => {
        await navigator.clipboard.writeText(barcode.replace(/\D/g, ''));
        message.success('Código copiado');
    };

    return (
        <S.BarcodeBox>
            <Tooltip title={barcode}>
                <S.BarcodeText>{barcode}</S.BarcodeText>
            </Tooltip>
            <Button size="small" icon={<Copy size={14} />} onClick={copy}>
                Copiar
            </Button>
        </S.BarcodeBox>
    );
}
